import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { addnowPlayingMovies } from "../utilities/movieSlice";
import { fetchMoviesWithFallback } from "../utilities/fetchWithFallback";

//fetching the now playing movies from the API and putting them to the redux store

const useNowPlayingMovies = () => {
const dispatch = useDispatch();
  useEffect(() => {
    const getPlayingMovies= async()=>{
    const results = await fetchMoviesWithFallback(
      'https://api.themoviedb.org/3/movie/now_playing?page=1',
      'now_playing'
    );
    dispatch(addnowPlayingMovies(results));
  }
    getPlayingMovies();
  }, [dispatch])
}

export default useNowPlayingMovies;